export const TACHO_CONTENT_SERVICE = [
	{ id: 1, text: 'Legalizacja i kalibracja tachografów' },
	{ id: 2, text: 'Diagnostyka i naprawa usterek' },
	{ id: 3, text: 'Montaż i wymiana tachografów' },
	{ id: 4, text: 'Odczyt i analiza danych z kart kierowców oraz tachografów' },
	{ id: 5, text: 'Doradztwo w zakresie prawidłowego użytkowania urządzeń' },
];
export const TACHO_CONTENT_INFO = [
	{ id: 1, text: 'Doświadczony zespół specjalistów' },
	{ id: 2, text: 'Szybka realizacja usług' },
	{ id: 3, text: 'Nowoczesne zaplecze techniczne' },
	{ id: 4, text: 'Konkurencyjne ceny' },
];
